import React, { useState } from 'react';
import { Alert, AppBar, Toolbar, Button, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import SelectAppStore from '../reqLab/appStore/SelectAppStore';

function LabConsolleManageAppVolPage(props) {
    const { labProps, setSelectedLabProps, queryClient } = props;
    const [repoPkgSel, setRepoPkgSel] = useState([]);
    const [, setRepoPkgBundleSel] = useState([]);
    const [isPkgListModified, setIsPkgListModified] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusRequest, setStatusRequest] = useState(null);
    const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
    const [hasSaved, setHasSaved] = useState(false);

    // Pacchetti appvol attualmente installati nel lab
    const installedAppVol = (labProps?.repoPkgSel || []).filter(p => p.source === 'appvol');

    const goBack = () => {
        if (hasSaved && queryClient) {
            queryClient.invalidateQueries({ queryKey: ['table-data'] });
        }
        props.setIsShowManageAppVolLab(false);
    };

    const handleBack = () => {
        if (isPkgListModified) {
            setShowUnsavedDialog(true);
        } else {
            goBack();
        }
    };

    const handleConfirmBack = () => {
        setShowUnsavedDialog(false);
        goBack();
    };

    const handleCancelBack = () => {
        setShowUnsavedDialog(false);
    };

    const handleSave = async () => {
        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            const url = process.env.REACT_APP_URL_MANAGE_LAB_APPVOL;

            const payload = {
                idLab: labProps.idLab,
                labType: labProps.labType,
                appVolPackages: repoPkgSel,
            };

            const formBody = [];
            formBody.push("payload=" + encodeURIComponent(JSON.stringify(payload)));

            const response = await fetch(url, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });

            const data = await response.json();
            setStatusRequest(data);

            if (data.statusRequest === 'success') {
                setIsPkgListModified(false);
                setHasSaved(true);
                // Aggiorna repoPkgSel nel parent così alla riapertura i dati sono freschi
                if (setSelectedLabProps) {
                    setSelectedLabProps(prev => ({
                        ...prev,
                        repoPkgSel: [
                            ...(prev?.repoPkgSel || []).filter(p => p.source !== 'appvol'),
                            ...repoPkgSel,
                        ],
                    }));
                }
                if (queryClient) {
                    queryClient.invalidateQueries({ queryKey: ['table-data'] });
                }
            }
        } catch (error) {
            console.log(error, "Errore nell'aggiornamento AppVol!");
            setStatusRequest({ statusRequest: 'error', message: 'Errore nell\'aggiornamento delle AppVol' });
        } finally {
            setTimeout(() => setIsSubmitting(false), 500);
        }
    };

    if (labProps) {
        return (
            <React.Fragment>
                <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                    <Toolbar sx={{ gap: 2 }}>
                        <IconButton edge="start" onClick={handleBack} disabled={isSubmitting}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography variant="h6" noWrap sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                                Gestione App Volumes
                            </Typography>
                            <Typography variant="body2" color="textSecondary" noWrap>
                                {labProps.labName} &mdash; {labProps.baseImage?.name}
                            </Typography>
                        </Box>
                        {statusRequest && (
                            <Typography
                                variant="body2"
                                color={statusRequest.statusRequest === 'success' ? 'success.main' : 'error'}
                                sx={{ flexShrink: 0 }}
                            >
                                {statusRequest.statusRequest === 'success'
                                    ? 'Gestione AppVol avviata con successo!'
                                    : statusRequest.message || 'Errore nell\'aggiornamento delle AppVol'}
                            </Typography>
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                            disabled={isSubmitting || !isPkgListModified}
                            onClick={handleSave}
                        >
                            {isSubmitting ? 'Salvando...' : 'Salva modifiche'}
                        </Button>
                    </Toolbar>
                </AppBar>

                <Box sx={{ p: 3 }}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                        Da questa pagina è possibile gestire le applicazioni App Volumes assegnate al laboratorio <strong>{labProps.labName}</strong> (idLab: {labProps.idLab})
                    </Alert>

                    <SelectAppStore
                        installedPackages={installedAppVol}
                        baseImage={labProps.baseImage}
                        setRepoPkgSel={setRepoPkgSel}
                        setRepoPkgBundleSel={setRepoPkgBundleSel}
                        setIsPkgListModified={setIsPkgListModified}
                        appvolOnly={true}
                    />
                </Box>

                <Dialog
                    open={showUnsavedDialog}
                    onClose={handleCancelBack}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Modifiche non salvate</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Hai effettuato modifiche che non sono state salvate.
                            Se esci senza salvare, le modifiche andranno perse.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleCancelBack}
                            color="primary"
                            variant="outlined"
                        >
                            Continua a modificare
                        </Button>
                        <Button
                            onClick={handleConfirmBack}
                            color="error"
                            variant="contained"
                        >
                            Abbandona modifiche
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    } else {
        return (
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar>
                    <IconButton edge="start" onClick={() => props.setIsShowManageAppVolLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                        Gestione App Volumes
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }
}

export default LabConsolleManageAppVolPage;
